/* eslint-disable no-console */
// import firebase from "firebase/app";
// import UserService from "@/services/UserService";
// import WordService from "@/services/WordService";

const actions = {
    updateUserLikedWords: ({ commit }, actions) => {
        commit("UPDATE_LIKED_WORDS", actions);
    },
    fetchUser: ({ commit, dispatch }, user) => {
        commit("SET_LOGGED_IN", user !== null);
        if (user) {
            commit("UPDATE_USER", {
                displayName: user.displayName,
                email: user.email,
                picture: user.photoURL
            });
            dispatch("fetchUserActions");
            dispatch("fetchUserIdToken");
        } else {
            commit("UPDATE_USER", null);
        }
    },
    // fetchUserIdToken: ({ commit }) => {
    //     firebase
    //         .auth()
    //         .currentUser.getIdToken(true)
    //         .then(idToken => {
    //             commit("SET_USER_ID_TOKEN", idToken);
    //             firebase
    //                 .auth()
    //                 .currentUser.getIdTokenResult()
    //                 .then(idTokenResult => {
    //                     let usprivacy = idTokenResult.claims && idTokenResult.claims.usprivacy;
    //                     commit("UPDATE_USPRIVACY", usprivacy || "1YNY");
    //                 });
    //             commit("DISPLAY_SAVE_WORD_POPUP", false);
    //         })
    //         .catch(error => {
    //             console.log("error while fetching user idToken", error);
    //         });
    // },
    // login: ({ dispatch }) => {
    //     firebase
    //         .auth()
    //         .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    //         .then(() => {
    //             const provider = new firebase.auth.GoogleAuthProvider();
    //             provider.addScope("profile");
    //             provider.addScope("email");

    //             return firebase.auth().signInWithPopup(provider);
    //         })
    //         .then(() => {
    //             dispatch("migrateOldLocalStorage");
    //         });
    // },
    // logout: ({ commit }) => {
    //     commit("DISPLAY_SAVE_WORD_POPUP", false);
    //     firebase
    //         .auth()
    //         .signOut()
    //         .then(() => {
    //             commit("SET_USER_ACTIONS", null);
    //             commit("DISPLAY_SAVE_WORD_POPUP", false);
    //         })
    //         .catch(err => {
    //             this.error = err;
    //             console.error(err);
    //         });
    // },
    // fetchUserActions: ({ commit }) => {
    //     firebase
    //         .auth()
    //         .currentUser.getIdToken(/* forceRefresh */ true)
    //         .then(idToken => {
    //             return UserService.getUserActions(idToken);
    //         })
    //         .then(resp => {
    //             const {
    //                 data: { actions }
    //             } = resp.data;
    //             commit("SET_USER_ACTIONS", actions);
    //         })
    //         .catch(err => {
    //             this.error = err;
    //             console.log(err);
    //         });
    // },
    updateUserStarredWords: ({ commit }, action) => {
        commit("UPDATE_STARRED_WORDS", action);
    },
    displaySaveWordPopup: ({ commit }, isVisible) => {
        commit("DISPLAY_SAVE_WORD_POPUP", isVisible);
    }
    // migrateOldLocalStorage: () => {
    //     firebase
    //         .auth()
    //         .currentUser.getIdToken()
    //         .then(idToken => {
    //             const starredWordsStored = JSON.parse(localStorage.getItem("my-starred-words"));
    //             if (starredWordsStored) {
    //                 Promise.all(
    //                     starredWordsStored.map(literal => WordService.getThesaurusRelation(literal))
    //                 )
    //                     .then(data => {
    //                         return UserService.starSynonym(idToken, {
    //                             action: "star",
    //                             relationIds: data
    //                         });
    //                     })
    //                     .then(result => {
    //                         if (result.data.data.result === "ok") {
    //                             localStorage.removeItem("my-starred-words");
    //                         }
    //                     })
    //                     .catch(err => {
    //                         console.error(err);
    //                     });
    //             }
    //         });
    // }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/Login/actions.js